// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-FlagIcon_cls1__OPV61","cls2":"VeloPhoneNumberField-FlagIcon_cls2__wE4-w VeloPhoneNumberField-FlagIcon_cls1__OPV61"};